import { render, staticRenderFns } from "./CustomerMobile.vue?vue&type=template&id=0b9ea182"
import script from "./CustomerMobile.vue?vue&type=script&lang=js"
export * from "./CustomerMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports